import UtilsTypes from './utils.types';
import { handleBlobChange } from './utils';

const initialUtilState = {
	errorPanel: {},
	errorMsg: '',
	alertMsg: '',
	redirect: {
		redirectUrl: '',
		redirect: false,
	},
	audioBlob: {},
	videoBlob: {},
	resetCounter: 0,
	resetCounters: [],
	showInstruction: 0,
	showError: false,
	showErrorOKbtn: false,
	showEcho: false,
	showPermitMic: false,
	showConfirmName: false,
};

export const setUtilsDetails = (state = initialUtilState, action = {}) => {
	switch (action.type) {
		case UtilsTypes.SET_ERROR_PANEL:
			return Object.assign({}, state, { errorPanel: action.payload });
		case UtilsTypes.SET_ERROR_MSG:
			return Object.assign({}, state, {
				errorMsg: action.payload,
				showError: true,
				showErrorOKbtn: action.payloadBtn ? action.payloadBtn : false
			});
		case UtilsTypes.SHOW_ERROR:
			return Object.assign({}, state, { errorMsg: '', showError: action.payload });
		case UtilsTypes.SET_ALERT_MSG:
			return Object.assign({}, state, { alertMsg: action.payload });
		case UtilsTypes.SET_REDIRECT_URL:
			return Object.assign({}, state, { redirect: { ...action.payload } });
		case UtilsTypes.HANDLE_BLOB_CHANGE:
			return Object.assign({}, state, {
				audioBlob: handleBlobChange({
					...action.payload,
					audioBlob: state.audioBlob,
				}),
			});
		case UtilsTypes.SHOW_INSTRUCTION:
			return Object.assign({}, state, { showInstruction: action.payload });
		case UtilsTypes.HANDLE_VIDEO_BLOB_CHANGE:
			return Object.assign({}, state, { videoBlob: action.payload });
		case UtilsTypes.SHOW_ECHO:
			return Object.assign({}, state, { showEcho: action.payload });
		case UtilsTypes.SHOW_PERMIT_MIC:
			return Object.assign({}, state, { showPermitMic: action.payload });
		case UtilsTypes.SHOW_CONFIRM_NAME:
			return Object.assign({}, state, { showConfirmName: action.payload });
		case UtilsTypes.RESET_AUDIO_BLOB:
			return Object.assign({}, state, { audioBlob: {} });

		default:
			return state;
	}
};